import { Component, OnInit, Output, ViewChild, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { contratosPorVencerTotal } from 'src/app/shared/models/home-contratoPorVencer.interface';
import { ContratoService } from '../../services/contratos/contrato.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-contratos-por-vencer',
  templateUrl: './contratos-por-vencer.component.html',
  styleUrls: ['./contratos-por-vencer.component.css']
})
export class ContratosPorVencerComponent implements OnInit {
  @Input() cargarTabla: boolean;
  @Output() countContratoVencer = new EventEmitter<number>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSourceContratos: any;
  displayedColumns: string[] = ['rut', 'nombreTrabajador', 'empresa', 'cargo', 'sucursal' ,'fechaTermino', 'diffDays'];
  loading: boolean = true; // SIRVE PARA CONTROLAR LOS SPINNERS DE CARGA

  contratosPorVencer: contratosPorVencerTotal[] = [];

  constructor(
    private contratoService: ContratoService,
    private _liveAnnouncer: LiveAnnouncer,

  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.contratoService.$contratosPorVencer.subscribe(contratos => {
      this.countContratoVencer.emit(contratos.length);
      this.contratosPorVencer = contratos.sort(
        (a: contratosPorVencerTotal, b: contratosPorVencerTotal) => a.diffDays - b.diffDays);
      this.cargarDatosTablaContratos();
    });
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (this.cargarTabla) {
  //     console.log({changes});
  //     this.cargarDatosTablaContratos();
  //   }
  // }

  cargarDatosTablaContratos() {
    this.dataSourceContratos = new MatTableDataSource(this.contratosPorVencer);

    this.dataSourceContratos.paginator = this.paginator;
    // CONFIGURA EL FILTRADO DE DATOS
    this.dataSourceContratos.filterPredicate = (data: contratosPorVencerTotal, filter: string) => {
      return data.nombreTrabajador.toLowerCase().includes(filter.toLowerCase())
        || data.empresa.toLowerCase().includes(filter.toLowerCase());
    };
    this.dataSourceContratos.sort = this.sort;

    this.loading = false;
    // console.log(this.dataSourceContratos.sort, this.dataSourceContratos.paginator);
  }

  // ORDENA LOS DATOS
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(event: Event) {
    //Funcion para filtar cualquier columna por el texto buscado
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceContratos.filter = filterValue.trim().toLowerCase();
  }

}
